export const dataSlider = [
   
  {
    id: 1,
    imgUrl: "banner_consultas.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://www.itetlax.org.mx/micrositio-consultas",
    linkToo: "https://www.itetlax.org.mx/micrositio-consultas",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  
  {
    id: 2,
    imgUrl: "banner_monografia.png",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/pdf/monografia.pdf",
    linkToo: "https://itetlax.org.mx/assets/pdf/monografia.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 3,
    imgUrl: "banner_muestral.png",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/pdf/documentos/estudio_muestral.pdf",
    linkToo: "https://itetlax.org.mx/assets/pdf/documentos/estudio_muestral.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },

  {
    id: 14,
    imgUrl: "Banner.webp",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/pdf/convocatorias/ORATORIA.pdf",
    linkToo: "https://itetlax.org.mx/assets/pdf/convocatorias/ORATORIA.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },

  {
    id: 13,
    imgUrl: "1.png",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/ite-genero/consulta_ine",
    linkToo: "https://itetlax.org.mx/ite-genero/consulta_ine",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },

  {
    id: 12,
    imgUrl: "FLYER_TEI_2026.png",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },

    /* 01/06/26 - 30/06/26 */
  {
    id: 7,
    imgUrl: "Carrusel_ATI.jpg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },  
  {
    id: 8,
    imgUrl: "banner_voces-01.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://participacion-ciudadana.itetlax.org.mx/nuestras_voces",
    linkToo: "",
    modalismage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 9,
    imgUrl: "banner_atcc_2.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://participacion-ciudadana.itetlax.org.mx/assets/pdf/_Estudio_Participacion.pdf",
    linkToo: "https://participacion-ciudadana.itetlax.org.mx/assets/pdf/_Estudio_Participacion.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },

  /* 30 de julio al 14 de agosto de 2026 */
  {
    id: 10,
    imgUrl: "banner_atcc_1.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://participacion-ciudadana.itetlax.org.mx/assets/pdf/_Informe_Resultados.pdf",
    linkToo: "https://participacion-ciudadana.itetlax.org.mx/assets/pdf/_Informe_Resultados.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 11,
    imgUrl: "Carrusel1-FULL.jpg",
    alt: "Banner",
    itemActive: "active",
    buttonActive: "",
    url: "",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 12,
    imgUrl: "Carrusel2-FULL.jpg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 13,
    imgUrl: "Carrusel3-FULL.jpg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 14,
    imgUrl: "Carrusel4-FULL.jpg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 15,
    imgUrl: "Carrusel5-FULL.jpg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },

 
];
